import axios from '@/utils/request'

export default {
  getCustomList: data => axios({ url: '/api/product/custom/getCustomList', method: 'POST', data }),//获取产品定制列表(后台)  
  getProductCustomDetail: id => axios({ url: `/api/product/custom/productCustomDetail/${id}`, method: 'GET' }),//获取产品定制详情(前后台)
  getPaymentLogList: params => axios({ url: '/api/product/custom/paymentLogList', method: 'GET', params }),//获取收款记录(前后台)
  getEditCustomStatus: data => axios({ url: '/api/product/custom/customStatus', method: 'PUT', data }),//更新定制状态(前后台)
  customCommentList: data => axios({ url: '/api/product/customComment/list', method: 'post', data }),//评论列表
  customCommentSave: data => axios({ url: '/api/product/customComment/save', method: 'post', data }),//新增评论
  customCommentDelete: id => axios({ url: `/api/product/customComment/delete/${id}`, method: 'delete' }),//删除评论
  customCommentDetail: id => axios({ url: `/api/product/customComment/get/${id}`, method: 'get' }),//评论详情
  customProductUploadFile: data => axios({ url: '/api/hbo/uploadFile', method: 'post', data }), // 上传文件阿里云文件服务器
  customProductGetSignValue: params => axios({ url: '/api/system/signValue', method: 'get', params }), // 获取阿里云文件服务器上传校验秘钥
  
  getProductSkuInfo: params => axios({ url: '/api/product/skuInfo', method: 'get', params }), // 获取商品系统sku信息（查询的是商品系统，sku不一定会在kakaclo的product和product_sku里面存在）
  createCustomOrder: data => axios({ url: '/api/product/custom/customKakaOrder', method: 'post', data }), // 创建kaka定制订单(后台)

  getSystemAddress: params => axios({ url: '/api/system/open/address', method: 'get', params }), // 获取地址信息数据字典
  
}